export default __webpack_public_path__ + "NewReportIcon.41d66735.png";